module.exports = __webpack_public_path__ + "fonts/steelfish.3e25fe69.woff";